import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@components/pd-media/pd-media'
import { IFullScreenTiling, paddingTopClassMap, paddingBottomClassMap } from '@common/pd-meta-components-types'
import TitleAndDesc from '../../title-and-desc'

const FullScreenTiling: FC<IFullScreenTiling> = ({ theme, aspectRatio, borderRadius, title, desc, mediaGroup, paddingTop = 'px120', paddingBottom = 'px0' }) => {
  if (!mediaGroup.length) {
    return null
  }

  return (
    <div className={clsx('w-full', paddingTopClassMap[paddingTop], paddingBottomClassMap[paddingBottom], `pd-theme-${theme}`, 'bg-container-primary')}>
      <div className={clsx('w-full')}>
        <TitleAndDesc title={title} desc={desc} />
        <div
          className={clsx(
            'flex w-full h-fit',
            'flex-col gap-8 mt-8',
            'laptop:flex-row laptop:gap-0.5 laptop:mt-16',
            'px-6 laptop:px-0'
          )}
        >
          {mediaGroup.map((item, index) => (
            <div
              key={index}
              className={clsx(
                'overflow-hidden',
                'flex-none',
                'laptop:flex-1',
                aspectRatio ? 'h-auto' : 'h-90 laptop:h-180'
              )}
              style={{
                aspectRatio: aspectRatio,
                borderRadius: borderRadius,
              }}
            >
              <PdMedia
                src={item.mediaUrl}
                mask={false}
                className="transition-transform ease-in-out duration-[800ms] hover:scale-110"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FullScreenTiling
